import React, { useState, useEffect, FC, useCallback } from "react";
import { Button } from "reactstrap";
import { TableColumnsType, } from "antd";
import {
  Icon,
} from "../../components/Component";
import { useNavigate } from "react-router";
import HandOverAside from "./HandOverAside";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import contractorsApis from "../../api/master/contractors";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";

const PendingHandover: FC = () => {
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [siteOptions, setSiteOptions] = useState<any>([]);

  const [contractorOptions, setContractorOptions] = useState<any>([]);
  const [allSiteIds, setAllSiteIds] = useState<string>("");

  const { data: currentUser } = useSelector(
    (state: RootState) => state.currentUser
  );

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  useEffect(() => {
    viewChange();
    // fetchAllInvoices();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility) {
        const options = currentUser.siteAccessibility.map((item: any) => ({
          label: item.siteName,
          value: item.siteID,
        }));
        setSiteOptions(options);

        const allIds = siteAccessibility.map((item: any) => item.siteID).join(",");
        setAllSiteIds(allIds);
      }
    }
  }, [currentUser]);


  const fetchContractorList = useCallback(async (siteIds: string) => {
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteIds // Pass all site IDs (comma-separated)
      });

      if (status && data) {
        const _contractorOptions = data.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));

        setContractorOptions(_contractorOptions);
      } else {
        setContractorOptions([]);
      }
    } catch (error) {
      setContractorOptions([]);
    }
  }, []);

  useEffect(() => {
    if (allSiteIds) {
      fetchContractorList(allSiteIds);
    }
  }, [allSiteIds, fetchContractorList]);

  const [columns, setColumns] = useState<TableColumnsType<any>>([
    {
      title: "#",
      key: "#",
      width: 50,
      render: (text, record, index) => index + 1,
      sorter: true,
    },
    {
      title: "Issue Number",
      dataIndex: "issueNumber",
      key: "issueNumber",
      width: 200,
      fixed: "left",
      render: (text) => (
        <div className="align-left">
          <span>{text || "NA"}</span>
        </div>
      ),
    },
    {
      title: "Site Name",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
      render: (text) => text || "NA",
    },
    {
      title: "Contractor",
      dataIndex: "contractorName",
      key: "contractorName",
      width: 200,
      render: (text: string) => text || "NA",
    },
    {
      title: "Issue Status",
      dataIndex: "issueStatus",
      key: "issueStatus",
      width: 200,
      render: (text) => text || "NA",
    },
    {
      title: "Handover Status",
      dataIndex: "handoverStatus",
      key: "handoverStatus",
      width: 200,
      render: (text) => text || "NA",
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
      render: (text) => text || "NA",
    },
    {
      title: "Creation Date",
      key: "createdAt",
      dataIndex: "createdAt",
      width: 200,
      render: (text, record) => (
        <span>{text ? dayjs(text).format("DD-MMM-YYYY") : "NA"}</span>
      ),
    },
    {
      title: "Action",
      key: "operation",
      width: 150,
      render: (text, record: any, index) => (
        <>
          <Button
            size="sm"
            color=""
            onClick={() => {
              navigate(
                `/material-handover-pending-details/${record.materialIssueId}`,
                {
                  state: {
                    screenStatus: "Pending",
                    fromPendingScreen: true
                  }
                }
              );
            }}
          >
            <Icon name="focus" />
          </Button>
        </>
      ),
    },
  ]);

  return (
    <>
      <TransactionFlowDefaultTemplate
        moduleKey="MaterialHandoverPendingList"
        title="Pending Handover"
        columns={columns}
        sideNavigation={
          <div
            className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${sm ? "content-active" : ""
              }`}
          >
            <HandOverAside updateSm={setSm} sm={sm} />
          </div>
        }
        selectFilters={[
          {
            title: "Site",
            placeholder: "Select Site",
            options: siteOptions,
            selectionMode: "multiple",
          },
          {
            title: "Contractor",
            placeholder: "Select Contractor",
            options: contractorOptions,
            selectionMode: "single",
          },
        ]}
        extra={{
          tableScrollX: 1100,
          dateRange: true,
          excelExport: false,
          dataFilterTootip: "Filtering based on creation date",
        }}
      />
    </>
  );
};

export default PendingHandover;